module.exports = __webpack_public_path__ + "static/img/ic_inquire@2x.27d36f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_inquire@2x.png
// module id = TzSV
// module chunks = 1